<template>
  <section :class="['support-file-picker', { compact, disabled }]" :aria-busy="disabled ? 'true' : 'false'">
    <header>
      <div>
        <strong>{{ $t("supportUi.evidence") }}</strong>
        <small v-if="!compact">{{ $t("supportUi.evidenceTip") }}</small>
      </div>
      <span class="picker-count">{{ files.length }} / 5</span>
    </header>

    <button
      type="button"
      class="support-upload-zone"
      data-analytics="support.attachment_choose"
      :disabled="disabled || files.length >= 5"
      @click="$emit('choose')"
    >
      <i class="el-icon-picture-outline" />
      <span>{{ $t("supportUi.chooseImages") }}</span>
      <small v-if="!compact">{{ $t("supportUi.evidenceTip") }}</small>
    </button>

    <div v-if="files.length" class="picked-files">
      <figure v-for="(item, index) in files" :key="item.key">
        <img :src="item.preview" :alt="$t('supportUi.imagePreview')">
        <button
          type="button"
          data-analytics="support.attachment_remove"
          :disabled="disabled"
          :aria-label="$t('supportUi.removeImage')"
          @click="$emit('remove', index)"
        >
          <i class="el-icon-close" />
        </button>
        <span v-if="item.progress > 0 && item.progress < 100"><b :style="{ width: item.progress + '%' }" /></span>
      </figure>
    </div>
  </section>
</template>

<script>
export default {
  name: "SupportFilePicker",
  props: {
    files: { type: Array, default: () => [] },
    compact: Boolean,
    disabled: Boolean
  }
}
</script>

<style scoped>
.support-file-picker{margin:4px 0 20px;padding:14px;border:1px solid #2b2d33;border-radius:17px;background:#15161a}.support-file-picker header{display:flex;align-items:flex-start;justify-content:space-between;gap:12px}.support-file-picker header>div{min-width:0}.support-file-picker header strong,.support-file-picker header small{display:block}.support-file-picker header strong{font-size:11px}.support-file-picker header small{margin-top:5px;color:#777981;font-size:9px}.picker-count{flex:none;padding:4px 8px;border:1px solid rgba(255,255,255,.08);border-radius:99px;background:#1d1e23;color:#8e9098;font-size:9px}.support-upload-zone{width:100%;min-height:82px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:5px;margin-top:12px;padding:12px;border:1px dashed rgba(255,105,128,.42);border-radius:14px;background:linear-gradient(145deg,rgba(255,79,106,.09),rgba(255,255,255,.025));color:#f3ece9}.support-upload-zone>i{color:#ff7185;font-size:23px}.support-upload-zone>span{font-size:11px;font-weight:700}.support-upload-zone>small{color:#777981;font-size:9px;line-height:1.45}.support-upload-zone:active:not(:disabled){transform:scale(.99)}.support-upload-zone:disabled{cursor:not-allowed;opacity:.48}.support-file-picker.disabled{opacity:.72}.picked-files{display:grid;grid-template-columns:repeat(5,minmax(0,1fr));gap:7px;margin-top:12px}.picked-files figure{position:relative;aspect-ratio:1;margin:0;overflow:hidden;border-radius:10px;background:#222}.picked-files img{width:100%;height:100%;object-fit:cover}.picked-files figure>button{position:absolute;inset-inline-end:3px;top:3px;width:20px;height:20px;padding:0;border:0;border-radius:50%;background:rgba(8,8,10,.75);color:#fff}.picked-files figure>button:disabled{opacity:.45}.picked-files figure>span{position:absolute;inset:0;display:flex;align-items:end;background:rgba(0,0,0,.3)}.picked-files figure>span b{height:3px;background:#ff6c80}.support-file-picker.compact{margin:0 0 8px;padding:8px 10px}.support-file-picker.compact header strong{font-size:9px}.support-file-picker.compact header small{display:none}.support-file-picker.compact .support-upload-zone{min-height:38px;flex-direction:row;margin-top:7px;padding:7px}.support-file-picker.compact .support-upload-zone>i{font-size:15px}.support-file-picker.compact .picked-files{margin-top:8px}
</style>
